import 'base-styles/reset.sss';
import 'base-styles/boltGlobal.sss';

import { h, render } from 'preact';
import { buildClientStoreData } from 'utils/bolt';
import BoltApp from 'base/bolt/boltApp';
import 'utils/historyPushEvent';

try {
	let url = location.origin + location.pathname.replace(/\/[^/]*$/, '/');
	if (location.protocol === 'about:' && window.parent !== window) {
		url = window.parent.location.origin + window.parent.location.pathname.replace(/\/[^/]*$/, '/');
	}

	// eslint-disable-next-line no-undef
	__webpack_public_path__ = url + (window.__RELATIVE_ROOT__ || '') + 'js/';
} catch (e) {}

let initialStore = buildClientStoreData(window.__INITIAL_STATE__);

let elem = document.getElementById('app') || document.body;
render(<BoltApp initialStore={initialStore} />, elem, elem.firstChild);
